import React, {PureComponent} from "react";
import {connect, DispatchProp} from "react-redux";
import {closeDialog} from "../../../store/dialog-manager/actions";
import {IDialogActionPayload, IDialogManagerState} from "../../../store/dialog-manager/types";
import {IApplicationState} from "../../../store";
import {dialogTemplates} from "./templates";
import playSound from "../../sounds/playSound";
import {AnimationSettingsProp} from "../../../store/settings/types";

class DialogManager extends PureComponent<IDialogManagerState & AnimationSettingsProp & DispatchProp> {
    render() {
        const {currentDialog} = this.props;

        if (!currentDialog)
            return null;

        const DialogRenderer = dialogTemplates[currentDialog.type];

        return (
            <DialogRenderer {...currentDialog.options} close={this.close.bind(this)} animation={this.props.animation}/>
        );
    }

    close(payload?: IDialogActionPayload) {
        playSound("button-click");
        this.props.dispatch(closeDialog(payload));
    }
}

export default connect(({ dialogs, settings }: IApplicationState) => ({
    currentDialog: dialogs.currentDialog,
    animation: settings.animation,
}))(DialogManager);